export default __webpack_public_path__ + "images/cz-8ef2bc6a4d5bad23e2843b0f7142f0c7.svg";